/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { type JSX } from 'react';

import { ReportsView } from '../reports/reports-view.js';

/** Admin → Reports (Figma). Progress, attendance, and revenue PDFs. */
export function AdminReportsPage(): JSX.Element {
  return <ReportsView titleKey="admin.reports.title" subtitleKey="admin.reports.count" />;
}
